import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/", label: "Dashboard", icon: "◉", end: true },
  { to: "/manage", label: "Manage", icon: "▦", end: false },
  { to: "/system", label: "System", icon: "▤", end: false },
  { to: "/settings", label: "Settings", icon: "⚙", end: false },
];

// Fixed bottom tab bar (mobile-first). Safe-area aware.
export function TabBar() {
  return (
    <nav className="tabbar">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.end} className="tab">
          <span className="tab-icon">{t.icon}</span>
          <span className="tab-label">{t.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
